import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';

import { loadConfig } from '../env/config_util';

const AuthProvider = (props) => {
  const config = loadConfig();

  return (
    <Auth0Provider
      domain={config.config_module.domain}
      clientId={config.config_module.client_id}
      redirectUri= {config.config_module.redirectUrl}
      scope="openid email profile read:roles"
    >
      {props.children}
    </Auth0Provider>
  );
};

export default AuthProvider;
